import React from 'react'; // Removed useState as it's now passed via props
import { FileText, Image, X } from 'lucide-react'; // Removed ShoppingCart, Banknote as they are not used in the modal itself

const PricingTable = ({ isPricingModalOpen, setIsPricingModalOpen, currentLanguage, setCurrentLanguage, getTranslatedText }) => {
  // The pricingData is now defined directly within this component
  const pricingData = [
    {
      sku: 'A4 Black and white',
      pricing: {
        '1 - 24': 500,
        '25 - 74': 300,
        '75+': 200
      }
    },
    {
      sku: 'A4 color',
      pricing: {
        '1 - 24': 800,
        '25 - 74': 600,
        '75+': 500
      }
    }
  ];

  // If the modal is not open, return null to render nothing
  if (!isPricingModalOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">
            {getTranslatedText('pricingTitle')}
          </h2>
          <button
            onClick={() => setIsPricingModalOpen(false)} // Close button
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          {/* Language Selector (within the modal) */}
          <div className="flex justify-center gap-2 mb-6">
            {['en', 'fr', 'es'].map((lang) => (
              <button
                key={lang}
                onClick={() => setCurrentLanguage(lang)} // Uses the setCurrentLanguage passed from App.jsx
                className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
                  currentLanguage === lang
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              >
                {lang.toUpperCase()}
              </button>
            ))}
          </div>

          {/* Pricing Table */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-blue-600 to-purple-600 text-white">
                    <th className="px-4 py-3 text-left font-semibold">
                      {getTranslatedText('sku')}
                    </th>
                    <th className="px-4 py-3 text-center font-semibold" colSpan="3">
                      {getTranslatedText('quantities')}
                    </th>
                  </tr>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2"></th>
                    <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">1 - 24</th>
                    <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">25 - 74</th>
                    <th className="px-4 py-2 text-center text-sm font-medium text-gray-700">75+</th>
                  </tr>
                </thead>
                <tbody>
                  {pricingData.map((item, index) => (
                    <tr key={index} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-blue-50 transition-colors`}>
                      <td className="px-4 py-3 font-medium text-gray-900">
                        {getTranslatedText(item.sku)}
                      </td>
                      <td className="px-4 py-3 text-center font-semibold text-blue-600">
                        {item.pricing['1 - 24']} {getTranslatedText('currency')}
                      </td>
                      <td className="px-4 py-3 text-center font-semibold text-blue-600">
                        {item.pricing['25 - 74']} {getTranslatedText('currency')}
                      </td>
                      <td className="px-4 py-3 text-center font-semibold text-blue-600">
                        {item.pricing['75+']} {getTranslatedText('currency')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

         
        </div>
      </div>
    </div>
  );
};

export default PricingTable;
